export default __webpack_public_path__ + "static/Muli-Bold-be4af426038d2aa130f12415322b178c.woff2";